export default {
  SEARCH_CATALOG_KUSPIT_OPERATION_QUERY: Symbol.for('SEARCH_CATALOG_KUSPIT_OPERATION_QUERY'),
  CATALOG_KUSPIT_OPERATION_REPOSITORY: Symbol.for('CATALOG_KUSPIT_OPERATION_REPOSITORY'),
  CATALOG_KUSPIT_OPERATION_STATE_MANAGER: Symbol.for('CATALOG_KUSPIT_OPERATION_STATE_MANAGER'),
};
